<script lang="tsx" setup>
defineProps<{
  to: string
  text: string
}>()
</script>

<template>
  <router-link class="link" :to="to" v-html="text" />
</template>
